<template>
  <div class="leaders-list">
    <!-- header部分表示用のコンポーネント -->
    <LeadersListHeader
      :headerImg="headerImg"
      :text="'本棚に戻る'"
      :routeUrl="'/fanClub/leaders'"
      :showSearch="true"
      :showButton="true"
      class="leaders-list-header"
      @handleSearchUpdate="search"
    />

    <!-- headerとの間に余白作るためのspanタグ -->
    <div class="header-space" />

    <!-- member情報を表示するコンポーネントにループでデータを渡す -->
    <div v-if="memberList.length != 0">
      <div
        :class="{ 'row-card': categoryCheck, 'column-card': !categoryCheck }"
      >
        <div
          v-for="(value, index) in memberList"
          :key="index"
          class="member-index"
          :class="{ 'flex-column': !categoryCheck }"
        >
          <LeadersMemberCard
            class="member-card-component"
            :id="value.id"
            :thumbnailUrl="value.thumbnailUrl"
            :categoryIconUrl="value.categoryIconUrl"
            :memberName="value.memberName"
            :prefecture="value.prefecture"
            :showCategoryIcon="value.showCategoryIcon"
            :categoryCheck="categoryCheck"
            @handleMoveDetail="handleMove"
          />
        </div>
      </div>

      <!-- VIEW MOREボタン表示 -->
      <div v-if="hasNext" class="more_page">
        <div @click="handleViewMore" class="view-more-wrapper">
          <p class="more-text">VIEW MORE</p>
          <span class="more-triangle" />
        </div>
      </div>
      <div v-else class="bottom-space" />
    </div>

    <div v-else-if="searchbefore" />

    <div v-else class="non-member">
      <p>該当者がいません。</p>
    </div>
  </div>
</template>

<script>
import LeadersListHeader from "@/components/fanClub/leaders/LeadersListHeader";
import LeadersMemberCard from "@/components/fanClub/leaders/LeadersMemberCard";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    LeadersListHeader,
    LeadersMemberCard
  },

  computed: {
    ...mapGetters("leaders", [
      "memberList",
      "hasNext",
      "nextPage",
      "headerImg",
      "scrollPositionY",
      "scrollPositionX"
    ])
  },

  data() {
    return {
      categoryCheck: false,
      categoryName: "",
      searchQuery: "",
      page: 1,
      searchbefore: true
    };
  },

  methods: {
    ...mapActions("leaders", [
      "getMemberList",
      "resetMemberList",
      "getHeaderImg",
      "setScrollPosition",
      "resetScrollPosition"
    ]),

    // 検索でmember情報更新する関数
    search(searchQuery) {
      console.log(this.memberList);
      this.resetMemberList();
      console.log(this.memberList);
      this.page = 1;
      this.searchQuery = searchQuery;
      console.log(this.searchQuery);
      this.getMemberList({
        categoryName: this.categoryName,
        page: this.page,
        searchQuery: this.searchQuery
      }).then(() => {
        if (this.memberList.length === 0) {
          this.searchbefore = false;
        } else {
          this.searchbefore = true;
        }
      });
      this.searchQuery = "";
    },
    // VIEW MOREをクリックした時にmember情報を取得する関数
    handleViewMore() {
      this.page = this.nextPage;
      this.getMemberList({
        categoryName: this.categoryName,
        page: this.page,
        searchQuery: this.searchQuery
      });
    },
    // member詳細ページに遷移する関数
    handleMove(id) {
      this.setScrollPosition();
      this.$router.push(`/fanClub/leaders/list/${this.categoryName}/${id}`);
    }
  },

  created() {
    // URLからクリックされた本のカテゴリー情報を取得する
    this.categoryName = this.$route.params.category;

    // categoryによるclassの変更チェック用変数の更新
    if (this.categoryName === "MILLIONAIRE" || this.categoryName === "CFC") {
      this.categoryCheck = true;
    }

    // header情報の取得API
    this.getHeaderImg(this.categoryName);

    // member情報の取得API
    if (this.memberList.length === 0) {
      this.getMemberList({
        categoryName: this.categoryName,
        page: this.page,
        searchQuery: this.searchQuery
      });
    }

    // スクロール位置の復元($nextTickはDOM更新が完了するまで待つ)
    this.$nextTick(() => {
      window.scrollTo(this.scrollPositionX, this.scrollPositionY);
    });
  }
};
</script>

<style lang="css" scoped>
.leaders-list {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 0;
}
.leaders-list::after {
  content: "";
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: -1;
  background-image: url("~@/assets/images/fanclub/leaders/BG_leaders_1920.png");
  background-size: contain;
}

.non-member {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: large;
  font-weight: bold;
}
.leaders-list-header {
  position: fixed;
  top: 0;
  left: 0;
}
.flex-column {
  max-width: 150px;
}
.column-card {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 auto;
}
.row-card {
  padding: 0 10%;
  max-width: 400px;
  margin: 0 auto;
}
.member-index {
  margin: auto;
  padding-bottom: 10%;
}
.more_page {
  display: flex;
  justify-content: end;
  padding: 10%;
}
.view-more-wrapper {
  border-bottom: solid 1px #000;
  display: flex;
  justify-content: space-between;
  width: 50%;
}
.more-triangle {
  border-bottom: 10px solid #000;
  border-left: 10px solid transparent;
  margin-bottom: 4%;
}
.more-text {
  margin-bottom: 4%;
  font-weight: bold;
}
.header-space {
  height: 150px;
}
.bottom-space {
  height: 70px;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/leaders/LeadersList.vue